module.exports = __webpack_public_path__ + "static/rainbow1-511ba949def2a4d7628d5d652dcba571.png";